/**
 * This is the recursive function that traverses the choice 
 * selections tree and then adds it into a string set
 * 
 * @param choiceSelectionsNode
 * @param acc 
 * @returns 
 */
function collectItemIds({
  choiceSelectionsNode,
  itemIds,
}: {
  choiceSelectionsNode: NestedChoiceSelection;
  itemIds: Set<string>;
}): void {
  if (!choiceSelectionsNode) return

  for (const value of Object.values(choiceSelectionsNode)) {
    const isChoiceWithChoiceSet = Array.isArray(value)

    if (isChoiceWithChoiceSet) {
      for (const id of value) itemIds.add(id);
    } else if (value && typeof value === 'object') {
      collectItemIds({ choiceSelectionsNode: value as ChoiceSelections, itemIds });
    }
  }
}

/**
 * Flatten's choice set selections for an item map into an
 * array for which we can check the availability of each choice
 */
export default function flattenChoiceSelections({
  choiceSelections,
}: {
  choiceSelections?: NestedChoiceSelection;
}): Set<string> {
  const itemIds = new Set<string>();
  
  if (!choiceSelections) return itemIds;

  collectItemIds({ choiceSelectionsNode: choiceSelections, itemIds });

  return itemIds
}
